/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
    'SolitaireShared/KlondikeLogic/ChallengeAuthorities/CardToCardDailyKlondikeAuthority',[
        'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/MoveState'
], function (IDailyKlondikeAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

        var Key_StackCard = "STACKCARD";
        var Key_BaseCard = "BASECARD";
        var TAG_CARDPLACED = 0x2;

        var CardToCardDailyKlondikeAuthority = function (param) {
            this.initCardToCardDailyKlondikeAuthority(param);
        };

        CardToCardDailyKlondikeAuthority.constructor = CardToCardDailyKlondikeAuthority;
        CardToCardDailyKlondikeAuthority.prototype = Object.create(IDailyKlondikeAuthority.prototype);

        CardToCardDailyKlondikeAuthority.prototype.initCardToCardDailyKlondikeAuthority = function (param) {
            IDailyKlondikeAuthority.call(this, param);

            this.GoalCompleted = false;

            if (param != null && param[Key_StackCard] && param[Key_BaseCard])
            {
                this.StackCard = param[Key_StackCard].toUpperCase();
                this.BaseCard = param[Key_BaseCard].toUpperCase();
            }
            else throw "Invalid parameter passed in creating Daily Challenge";
        };

        Object.defineProperty(CardToCardDailyKlondikeAuthority.prototype, "ChallengeType", {
            get: function () {
                return IDailyAuthority.ChallengeType.CardToCard;
            }
        });

        CardToCardDailyKlondikeAuthority.prototype.Deal = function ()  {
            this.GoalCompleted = false;

            return IDailyKlondikeAuthority.prototype.Deal.call(this);
        };

        CardToCardDailyKlondikeAuthority.prototype.GetScoreForAction = function (action) {
            for (var i = 0; i < action.Ops.length; i++)
            {
                var op = action.Ops[i];
                var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
                if (op.Opcode == CardOp.Op.Move && destPile.Type == "Tableau" && destPile.Count > op.GetNumber(CardOp.eMoveParams.NumCards))
                {
                    if (destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards)).ToString().Equals(this.StackCard)
                        && destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards) + 1).ToString().Equals(this.BaseCard))
                    {
                        action.Tag = (action.Tag | TAG_CARDPLACED) >>> 0;
                        break;
                    }
                }
            }

            return IDailyKlondikeAuthority.prototype.GetScoreForAction.call(this, action);
        };

        CardToCardDailyKlondikeAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
            if (((tag & TAG_CARDPLACED) >>> 0) != 0)
            {
                this.GoalCompleted = true;
            }

            IDailyKlondikeAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
        };

        CardToCardDailyKlondikeAuthority.prototype.IsGameWon = function () {
            return (!this.CardSupply.WaitingForAnimation) && this.GoalCompleted;
        };

        CardToCardDailyKlondikeAuthority.prototype.CurrentMoveState = function ()
        {
            if (!this.IsGameWon() && IDailyKlondikeAuthority.prototype.IsGameWon.call(this))
                return MoveState.NoMovesLeft;

            return IDailyKlondikeAuthority.prototype.CurrentMoveState.call(this);
        };

        return CardToCardDailyKlondikeAuthority;

});
